__turbopack_context__.v({
  "root": "BulkActionsBarWrapper-module__0HcGIq__root",
});
